import { render } from "./cwbg.vue?vue&type=template&id=7a01ed92&scoped=true&ts=true"
import script from "./cwbg.vue?vue&type=script&lang=ts"
export * from "./cwbg.vue?vue&type=script&lang=ts"

import "./cwbg.vue?vue&type=style&index=0&id=7a01ed92&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a01ed92"]])

export default __exports__